// extracted by mini-css-extract-plugin
export var editInput = "_fi-0";
export var editInputCompact = "_fi-2";
export var editInputLarge = "_fi-1";
export var editInputSmall = "_fi-3";